export default Object.freeze({
  User: 'User',
  Manager: 'Manager',
});
